// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"320":"8be5c9ae","383":"1adec88a"}[chunkId] + ".chunk.css";
};